import { put, call, takeEvery } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import {
  FEED_MAPPINGS_REQUEST,
  FEED_MAPPING_REQUEST,
  CREATE_FEED_MAPPING_REQUEST,
  UPDATE_FEED_MAPPING_REQUEST,
  DELETE_FEED_MAPPING_REQUEST,
} from './actionTypes';
import {
  feedMappingsSuccess,
  feedMappingsFailure,
  feedMappingSuccess,
  feedMappingFailure,
  createFeedMappingSuccess,
  createFeedMappingFailure,
  updateFeedMappingSuccess,
  updateFeedMappingFailure,
  deleteFeedMappingSuccess,
  deleteFeedMappingFailure,
} from './actions';
import FeedMappingService from '../../services/FeedMappingService';

export function* getFeedMappingsTask() {
  try {
    const list = yield call(FeedMappingService.getFeedMappings);
    yield put(feedMappingsSuccess(list));
  } catch (error) {
    yield put(feedMappingsFailure(error));
  }
}

export function* getFeedMappingTask(action) {
  try {
    const feedMappingId = action.payload;
    const feedMapping = yield call(
      FeedMappingService.getFeedMapping,
      feedMappingId,
    );
    yield put(replace(`/feedMapping/${feedMappingId}`));
    yield put(feedMappingSuccess(feedMapping));
  } catch (error) {
    yield put(feedMappingFailure(error));
  }
}

export function* createFeedMappingTask(action) {
  try {
    const params = action.payload;
    const feedMapping = yield call(
      FeedMappingService.createFeedMapping,
      params,
    );
    yield put(createFeedMappingSuccess(feedMapping));
    yield put(replace(`/feedMapping/${feedMapping.id}`));
  } catch (error) {
    yield put(createFeedMappingFailure(error));
  }
}

export function* updateFeedMappingTask(action) {
  try {
    const feedMapping = action.payload;
    const updatedFeedMapping = yield call(
      FeedMappingService.updateFeedMapping,
      feedMapping,
    );
    yield put(updateFeedMappingSuccess(updatedFeedMapping));
    yield put(replace('/feedMappings'));
  } catch (error) {
    yield put(updateFeedMappingFailure(error));
  }
}

export function* deleteFeedMappingTask(action) {
  try {
    const feedMappingId = action.payload;
    yield call(FeedMappingService.deleteFeedMapping, feedMappingId);
    yield put(deleteFeedMappingSuccess(feedMappingId));
  } catch (error) {
    yield put(deleteFeedMappingFailure(error));
  }
}

export function* feedMappingsSaga() {
  yield takeEvery(FEED_MAPPINGS_REQUEST, getFeedMappingsTask);
  yield takeEvery(FEED_MAPPING_REQUEST, getFeedMappingTask);
  yield takeEvery(CREATE_FEED_MAPPING_REQUEST, createFeedMappingTask);
  yield takeEvery(UPDATE_FEED_MAPPING_REQUEST, updateFeedMappingTask);
  yield takeEvery(DELETE_FEED_MAPPING_REQUEST, deleteFeedMappingTask);
}
